import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import {
  Wrapper,
  Content,
  ContainerText,
  Text,
  Welcome,
  Title,
  Animation,
  Subtitle,
  CallToAction,
} from "./styled"

import "./title-animation.css"

const HeroHome = () => {
  const { text } = useStaticQuery(
    graphql`
      query {
        text: file(relativePath: { eq: "hero-home.png" }) {
          childImageSharp {
            fluid(maxWidth: 600) {
              ...GatsbyImageSharpFluid_tracedSVG
            }
          }
        }
      }
    `
  )

  return (
    <Wrapper Tag="div" fluid={text.childImageSharp.fluid}>
      <Content>
        <ContainerText>
          <Text>
            <Welcome>Seja bem-vindo(a)!</Welcome>
            <Title>
              Desenvolvendo
              <Animation>
                {" "}
                <span class="text_1"> conhecimento &nbsp;</span>
                <span class="text_2"> conexões &nbsp;</span>
              </Animation>
            </Title>
            <Subtitle>Para o seu dia-a-dia</Subtitle>
          </Text>
          <CallToAction href="/posts">Ver posts</CallToAction>
        </ContainerText>
      </Content>
    </Wrapper>
  )
}

export default HeroHome
